export default {
  USER: {
    UPDATE_PROFILE: 'user/updateProfile',
  },
  REPORT: {
    SET_REPORTS: 'report/setReports',
    SET_REPORT: 'report/setReport',
    UPDATE_REPORT: 'report/updateReport',
    DELETE_REPORT: 'report/deleteReport',
  },
  ANALYSIS: {
    SET_MODULES: 'modules/setModules',
    SET_MODULES_SUMMARY: 'modules/setModulesSummary',
    SET_MODULES_INFO: 'modules/setModulesInfo',
    SET_RUNS: 'analysis/setRuns',
    SET_CONTEXT_VARIANT_GAPS: 'analysis/setContextVariantGaps',
    SET_CONTEXT_VARIANT_GAP_LATEST: 'analysis/setContextVariantGapLatest',
    SET_CONTEXT_VARIANTS_INFO: 'analysis/setContextVariantsInfo',
    SET_MODULE_GAPS_LATEST: 'analysis/setModuleGapsLatest',
    SET_DETAILED_GAP_DESCRPTION: 'analysis/setDetailedGapDescription',
    SET_CONFIGURATION: 'analysis/setConfiguration',
    SET_CHARACTERISTICS: 'analysis/setCharacteristics',
    INITIALIZE_VARIABLES: 'analysis/initializeVariables',
    SET_DIVERSITY_VARIANTS: 'analysis/setDiversityVariants',
    SAVE_DIVERSITY_VARIANT: 'analysis/saveDiversityVariant',
    SET_CONTEXT_MODELS: 'analysis/setContextModels',
    SAVE_DIVERSITY_MODELS: 'analysis/saveDiversityModels',
    SET_EMPIRICAL_CONCEPT_CONFIGS_FOR_INDEPENDENT_CHARACTERISTICS:
      'analysis/setEmpiricalConceptConfigsForIndependentCharacteristics',
    SET_EMPIRICAL_CONCEPT_CONFIGS_FOR_DESCRIPTIVE_CHARACTERISTICS:
      'analysis/setEmpiricalConceptConfigsForDescriptiveCharacteristics',
    SET_EMPIRICAL_CONCEPTS_INFO: 'analysis/setEmpiricalConceptsInfo',
    SAVE_INDEPENDENT_CHARACTERISTICS: 'analysis/saveIndependentCharacteristics',
    SAVE_INDEPENDENT_CHARACTERISTICS_CONSTANT: 'analysis/saveIndependentCharacteristicsConstant',
    SAVE_DESCRIPTIVE_CHARACTERISTICS: 'analysis/saveDescriptiveCharacteristics',
    TRIGGER_ANALYSIS: 'analysis/triggerAnalysis',
    SET_RUNS_FOR_ETRL_KPIS: 'analysis/setRunsForETRLKPIs',
    SET_KPIS_FOR_CURRENT_RUN: 'analysis/setKPIsForCurrentRun',
    SET_OFA_VALUES: 'analysis/setOFAValues',
    SET_OFA_OVERALL: 'analysis/setOFAOverall',
    SET_CWI_MAPPINGS: 'analysis/setCWIMappings',
  },
  ETL: {
    SET_ETL_STATUS: 'etl/setETLStatus',
    SET_ETL_FILES: 'etl/setETLFiles',
    SET_ETL_PROCESSED_FILE: 'etl/setETLProcessedFile',
    UPLOAD_FILES: 'etl/uploadFiles',
    GET_FILE_MAPPINGS: 'etl/getFileMappings',
    SET_FILE_MAPPINGS: 'etl/setFileMappings',
    GET_ETLS: 'etl/getETLS',
    SET_ETL: 'etl/setETL',
    UPDATE_ETL: 'etl/updateETL',
    DELETE_ETL: 'etl/deleteETL',
    GET_FILE_CHARACTERISTICS: 'etl/getETLCharacteristics',
    SET_FILE_CHARACTERISTICS: 'etl/setETLFileCharacteristics',
    UPDATE_FILE_CHARACTERISTICS: 'etl/updateETLCharacteristics',
    GET_QUESTIONS: 'etl/getETLQuestions',
    SET_QUESTIONS: 'etl/setETLQuestions',
    UDATE_QUESTIONS: 'etl/updateETLQuestions',
    DELETE_QUESTIONS: 'etl/deleteETLQuestions',
    ADD_QUESTION: 'etl/addETLQuestion',
    GET_VARIABLES: 'etl/getETLVariables',
    GET_ORIGINAL_VALUES: 'etl/getOriginalValues',
    ADD_VARIABLE: 'etl/addVariable',
    UPDATE_VARIABLE: 'etl/updateVariable',
    DELETE_VARIABLE: 'etl/deleteVariable',
    DELETE_CHAR_VARIABLE: 'etl/deleteCharVariable',
    UPDATE_ETL_STEP: 'etl/updateEtlStep',
    GO_BACK: 'etl/goBackETLStep',
    GET_FINAL_ERRORS: 'etl/getFinalErrors',
    UPDATE_ETL_ERROR: 'etl/updateError',
    REPORT_ETL_ERRORS: 'etl/reportEtlErrors',
  },
  PT: {
    SET_PT_RUNS: 'pt/setPTRuns',
    SET_PT_KPIS_FOR_CURRENT_RUN: 'pt/setPTKPIsForCurrentRuns',
  },
}
